import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from "@angular/common";

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpResponseInterceptor } from './interceptors/HttpResponse.interceptor';
import { VersionInterceptor } from './interceptors/Version.interceptor';

export const AppInterceptorsProvider = [
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true},
];
